import { InputLabel, FormHelperText } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { pickersMigrationHack } from '../utils/utils';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import {enGB} from 'date-fns/locale'
import 'dayjs/locale/en';
interface MDatePickerProps {
  label?: string;
  value?: Date | null;
  onChange: (date: Date | null) => void;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
}

export const MDatePicker = (props: MDatePickerProps) => {
  const { label, value = null, onChange, disabled, error, helperText } = props;

  return (
    <>
        <LocalizationProvider adapterLocale={enGB}>
          {label && <InputLabel>{label}</InputLabel>}
            <DatePicker
                value={value ? new Date(value) : null}
                onChange={onChange}
                disabled={disabled}
                sx={{
                  width: "100%",
                  ...pickersMigrationHack(error)
                }}
              />
              {error ? <FormHelperText sx={{ color: error ? '#d32f2f' : 'inherit' }}>{helperText}</FormHelperText> : <></>}
        </LocalizationProvider>
    </>
  );
}

export default MDatePicker;
